import { render, staticRenderFns } from "./SoftwareComponentVersionSingleAdd.vue?vue&type=template&id=0322869e&scoped=true&"
import script from "./SoftwareComponentVersionSingleAdd.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentVersionSingleAdd.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentVersionSingleAdd.vue?vue&type=style&index=0&id=0322869e&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0322869e",
  null
  
)

export default component.exports